(function () {
  /* ===============================
     CONFIG
  =============================== */

  const REQUIRED_QTY = 2;
  const COUPON = 'FORMULA40';

  // Fórmulas unitárias (product_id)
  // IMPORTANTE:
  // Toda nova fórmula deve ser adicionada em FORMULA_PRODUCTS,
  // caso contrário não contará para a barra de progresso e desconto.
  const FORMULA_PRODUCTS = [
    8761019367581,
    8761032310941,
    8761031655581,
    8761022152861,
    8761020121245,
    8761019793565,
    8761031917725,
    8840279326877,
    8948380401821,
    8874628284573,
    8957545087133,
  ];

  // Produtos que NUNCA devem contar como fórmula
  const BLOCKED_FORMULA_PRODUCTS = [
    8969421848733
  ];

  // Fórmulas unitárias por handle
  const FORMULA_HANDLES = [
    'exo-peptide-ghk-cu-pre-venda',
    'pdrn-jelly-cream',
    'ghk-cu-cooper-peptide'
  ];

  // KITS/ROTINAS por handle
  const KIT_HANDLES = [
    'linhas-finas-rugas-firmeza',
    'brilho-hidratacao',
    'acne-poros-oleosidade',
    'adah-full-experience',
    'trio-korean-antiaging',
    'trio-oil-control',
    'trio-barrier-defense',
    'trio-k-boost',
    'trio-skin-renew',
    'trio-glass-skin'
  ];

  // Equivalência padrão dos kits
  const KIT_EQUIVALENCE_DEFAULT = 3;

  // Regras forçadas/exceções específicas
  const FORCED_KIT_RULES = [
    {
      equiv: 2,
      variantIds: [8803803234461],
      titleMust: ['rotina', 'acne', 'poros', 'oleos', 'salicylic', 'niacid']
    },
    {
      equiv: 2,
      variantIds: [47739281539229],
      titleMust: ['rotina', 'korean', 'anti-aging']
    },
    {
      equiv: 3,
      productIds: [8932470915229],
      titleMust: ['trio', 'korean', 'anti-aging']
    },
    {
      equiv: 3,
      productIds: [8958392893597],
      titleMust: ['trio', 'oil', 'control']
    },
    {
      equiv: 3,
      productIds: [8958392271005],
      titleMust: ['trio', 'barrier', 'defense']
    },
    {
      equiv: 3,
      productIds: [8958391746717],
      titleMust: ['trio', 'k-boost']
    },
    {
      equiv: 3,
      productIds: [8958390894749],
      titleMust: ['trio', 'skin', 'renew']
    },
    {
      equiv: 3,
      productIds: [8958389813405],
      titleMust: ['trio', 'glass', 'skin']
    },
    {
      equiv: 2,
      productIds: [8963408756893],
      titleMust: ['protocolo', 'k-regen']
    },
    {
      equiv: 2,
      productIds: [8971765317789],
      titleMust: ['duo', 'day' , 'night' , 'protection']
    },
    {
      equiv: 2,
      productIds: [8981651095709],
      titleMust: ['duo', 'radiance']
    },
    {
      equiv: 2,
      productIds: [8985579520157],
      titleMust: ['duo', 'pdrn' , 'ghk-cu']
    },
  ];

  // Upsell
  const UPSELL_SELECTORS = [
    '.cart-drawer_upsell.upsell-list'
  ];

  let lastQty = -1;
  let lastDiscountState = null;
  let debounceTimer = null;
  let fetchHooked = false;
  let domObserverStarted = false;
  let pendingOptimisticQty = 0;

  // product_ids reais dos kits resolvidos via /products/{handle}.js
  const KIT_PRODUCT_IDS = new Set();
  let kitsLoadedPromise = null;

  /* ===============================
     HELPERS
  =============================== */

  function norm(str) {
    return String(str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function textMatchesAll(text, mustList) {
    const t = norm(text);
    if (!t || !Array.isArray(mustList) || !mustList.length) return false;
    return mustList.every((k) => t.includes(norm(k)));
  }

  function urlHasAnySlug(urlStr, slugs) {
    const u = norm(urlStr);
    if (!u) return false;
    return slugs.some((s) => {
      const slug = norm(s);
      return u.includes('/products/' + slug) || u.includes(slug);
    });
  }

  function getVariantId(item) {
    return Number((item && (item.variant_id || item.id)) || 0);
  }

  function getProductId(item) {
    return Number((item && item.product_id) || 0);
  }

  function getItemTitle(item) {
    return norm(item && (item.product_title || item.title || ''));
  }

  function getItemHandle(item) {
    return norm(item && item.handle);
  }

  function getItemUrl(item) {
    return norm(item && item.url);
  }

  function findForcedKitRule(item) {
  if (!item) return null;

  const vid = getVariantId(item);
  const pid = getProductId(item);
  const title = getItemTitle(item);

  for (const rule of FORCED_KIT_RULES) {
    if (Array.isArray(rule.variantIds) && rule.variantIds.includes(vid)) {
      return rule;
    }

    if (Array.isArray(rule.productIds) && rule.productIds.includes(pid)) {
      return rule;
    }

    if (Array.isArray(rule.titleMust) && title && textMatchesAll(title, rule.titleMust)) {
      return rule;
    }
  }

  return null;
}

  function getKitEquivalence(item) {
    if (!item) return 0;

    // 1) regra forçada primeiro
    const forcedRule = findForcedKitRule(item);
    if (forcedRule && Number(forcedRule.equiv) > 0) {
      return Number(forcedRule.equiv);
    }

    // 2) kit por product_id resolvido via handle
    const pid = getProductId(item);
    if (pid && KIT_PRODUCT_IDS.has(pid)) {
      return KIT_EQUIVALENCE_DEFAULT;
    }

    // 3) fallback por handle
    const handle = getItemHandle(item);
    if (handle && KIT_HANDLES.includes(handle)) {
      return KIT_EQUIVALENCE_DEFAULT;
    }

    // 4) fallback por url
    const url = getItemUrl(item);
    if (url && urlHasAnySlug(url, KIT_HANDLES)) {
      return KIT_EQUIVALENCE_DEFAULT;
    }

    return 0;
  }

  function isFormulaProduct(item) {
  if (!item) return false;

  const pid = getProductId(item);

  if (BLOCKED_FORMULA_PRODUCTS.includes(pid)) {
    return false;
  }

  if (pid && FORMULA_PRODUCTS.includes(pid)) {
    return true;
  }

  const handle = getItemHandle(item);
  if (handle && FORMULA_HANDLES.includes(handle)) {
    return true;
  }

  const url = getItemUrl(item);
  if (url && urlHasAnySlug(url, FORMULA_HANDLES)) {
    return true;
  }

  return false;
}

  async function loadKitProductIdsOnce() {
    if (kitsLoadedPromise) return kitsLoadedPromise;

    kitsLoadedPromise = Promise.all(
      KIT_HANDLES.map(async (handle) => {
        try {
          const r = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
            credentials: 'same-origin'
          });

          if (!r.ok) return null;

          const data = await r.json();
          const pid = Number(data && data.id);

          if (pid) KIT_PRODUCT_IDS.add(pid);
          return pid || null;
        } catch (e) {
          return null;
        }
      })
    );

    return kitsLoadedPromise;
  }

  /* ===============================
     CART
  =============================== */

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  function countFormulas(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce((total, item) => {
      const qty = Number(item.quantity || 0);
      if (!qty) return total;

      const kitEquiv = getKitEquivalence(item);
      if (kitEquiv > 0) {
        return total + (qty * kitEquiv);
      }

      if (isFormulaProduct(item)) {
        return total + qty;
      }

      return total;
    }, 0);
  }

  function applyCoupon() {
    return fetch('/discount/' + encodeURIComponent(COUPON), {
      credentials: 'same-origin'
    }).catch(() => null);
  }

  function removeCoupon() {
    return fetch('/discount/', {
      credentials: 'same-origin'
    }).catch(() => null);
  }

  /* ===============================
     VISIBILITY
  =============================== */

  function setElHidden(el, hidden) {
    if (!el) return;
    el.style.display = hidden ? 'none' : '';
    el.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  }

  function setUpsellHidden(hidden) {
    UPSELL_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        setElHidden(el, hidden);
      });
    });
  }

  function setFormulaBarHidden(hidden) {
    const bar = document.getElementById('formula-bar');
    setElHidden(bar, hidden);
  }

  /* ===============================
     RENDER
  =============================== */

  function renderBar(qty) {
    const bar = document.getElementById('formula-bar');
    if (!bar) return false;

    const fill = bar.querySelector('#formula-progress-fill');
    const status = bar.querySelector('#formula-status');
    const text = bar.querySelector('#formula-text');

    if (!fill || !status || !text) return false;

    const safeQty = Math.max(0, Math.min(Number(qty || 0), REQUIRED_QTY));
    const percent = (safeQty / REQUIRED_QTY) * 100;

    fill.style.width = percent + '%';
    status.textContent = safeQty + ' / ' + REQUIRED_QTY;

    if (qty <= 0) {
      text.innerHTML = 'Levando 2 fórmulas, você ganha 40% OFF.';
    } else if (qty >= REQUIRED_QTY) {
      text.innerHTML = 'Você Ganhou <strong class="formula-code">40% OFF</strong> + Frete Grátis';
    } else {
      text.innerHTML =
        'Adicione + <strong>' +
        (REQUIRED_QTY - safeQty) +
        '</strong> Fórmula para Ganhar <strong>40% OFF</strong>';
    }

    bar.setAttribute('data-rendered-qty', String(qty));
    return true;
  }

  async function syncDiscountState(qty) {
    const shouldHaveDiscount = qty >= REQUIRED_QTY;

    if (lastDiscountState === shouldHaveDiscount) return;

    lastDiscountState = shouldHaveDiscount;

    if (shouldHaveDiscount) {
      await applyCoupon();
    } else {
      await removeCoupon();
    }
  }

  async function updateFormulaBar() {
    await loadKitProductIdsOnce();

    const cart = await getCart();
    const qty = countFormulas(cart);

    setFormulaBarHidden(false);
    setUpsellHidden(false);

    const bar = document.getElementById('formula-bar');
    const renderedQty = bar ? Number(bar.getAttribute('data-rendered-qty')) : NaN;
    const needsRender = !Number.isFinite(renderedQty) || renderedQty !== qty;

    if (qty !== lastQty || needsRender) {
      lastQty = qty;
      renderBar(qty);
    }

    pendingOptimisticQty = 0;
    await syncDiscountState(qty);
  }

  function scheduleUpdate(delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateFormulaBar, Number(delay || 120));
  }

  /* ===============================
     OPTIMISTIC UI
  =============================== */

  function optimisticAdvance(byQty) {
    pendingOptimisticQty = Math.max(pendingOptimisticQty, Number(byQty || 0));

    const optimisticQty = Math.max(0, lastQty) + pendingOptimisticQty;
    renderBar(optimisticQty);
  }

  /* ===============================
     OBSERVERS
  =============================== */

  function observeFormulaBarInDom() {
    if (domObserverStarted) return;
    domObserverStarted = true;

    const obs = new MutationObserver(() => {
      const bar = document.getElementById('formula-bar');
      if (!bar) return;

      if (bar.getAttribute('data-rendered-qty') == null) {
        renderBar(Math.max(0, lastQty));
      }

      scheduleUpdate(120);
    });

    obs.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function observeCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const observer = new MutationObserver(() => {
      scheduleUpdate(120);
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true
    });
  }

  /* ===============================
     FETCH HOOK
  =============================== */

  function hookFetchOnce() {
    if (fetchHooked) return;
    fetchHooked = true;

    const originalFetch = window.fetch;

    window.fetch = function () {
      return originalFetch.apply(this, arguments).then((res) => {
        try {
          const url = String((res && res.url) || '');

          if (
            url.includes('/cart/add') ||
            url.includes('/cart/change') ||
            url.includes('/cart/update') ||
            url.includes('/cart/clear')
          ) {
            scheduleUpdate(100);
          }
        } catch (e) {}

        return res;
      });
    };
  }

  /* ===============================
     CLICK NO COMPRAR
  =============================== */

  function hookAddClick() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('button[name="add"]');
      if (!btn) return;

      const form = btn.closest('form');
      if (!form) return;

      const idEl =
        form.querySelector('input[name="id"]') ||
        form.querySelector('input[name="variant_id"]');

      if (!idEl) return;

      const variantId = Number(idEl.value || 0);
      if (!variantId) return;

      const forcedRule = FORCED_KIT_RULES.find((rule) => {
        return Array.isArray(rule.variantIds) && rule.variantIds.includes(variantId);
      });

      if (forcedRule && Number(forcedRule.equiv) > 0) {
        optimisticAdvance(Number(forcedRule.equiv));
        return;
      }

      // tenta detectar product_id
      const productIdEl =
        form.querySelector('input[name="product-id"]') ||
        form.querySelector('input[name="product_id"]') ||
        form.querySelector('[data-product-id]');

      let maybeProductId = 0;

      if (productIdEl) {
        maybeProductId = Number(
          productIdEl.value ||
          productIdEl.getAttribute('data-product-id') ||
          0
        );
      }

      if (maybeProductId && FORMULA_PRODUCTS.includes(maybeProductId)) {
        optimisticAdvance(1);
        return;
      }

      // fallback por handle/url do formulário
      const action = norm(form.getAttribute('action') || '');
      const formHandleEl =
        form.querySelector('input[name="handle"]') ||
        form.querySelector('[data-product-handle]');

      const maybeHandle = norm(
        (formHandleEl && (formHandleEl.value || formHandleEl.getAttribute('data-product-handle'))) || ''
      );

      if (
        (maybeHandle && FORMULA_HANDLES.includes(maybeHandle)) ||
        (action && urlHasAnySlug(action, FORMULA_HANDLES))
      ) {
        optimisticAdvance(1);
      }
    });
  }

  /* ===============================
     INIT
  =============================== */

  document.addEventListener('DOMContentLoaded', () => {
    observeFormulaBarInDom();
    observeCartDrawer();
    hookFetchOnce();
    hookAddClick();

    loadKitProductIdsOnce().finally(() => {
      scheduleUpdate(0);
    });
  });
})();